import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  AddCustomNotificationPayload,
  DeleteCustomNotificationPayload,
  FetchCustomNotificationsPayload,
  ICustomNotification,
} from '../types/custom-notification.types';

export const customNotificationApi = createApi({
  reducerPath: 'customNotificationApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/platform-settings/notifications`),
  endpoints: (builder) => ({
    fetchNotifications: builder.query<ApiPaginationResponse<ICustomNotification[]>, FetchCustomNotificationsPayload>({
      query: (payload) => ({
        url: ``,
        method: 'GET',
        params: payload,
      }),
    }),

    addNotification: builder.mutation<ApiResponse<ICustomNotification>, AddCustomNotificationPayload>({
      query: (payload) => ({
        url: ``,
        method: 'POST',
        body: payload,
      }),
    }),

    deleteNotification: builder.query<ApiResponse<void>, DeleteCustomNotificationPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useAddNotificationMutation, useLazyDeleteNotificationQuery, useLazyFetchNotificationsQuery } =
  customNotificationApi;
